import { render, staticRenderFns } from "./TotalTurnoverToPlayTurnTable.vue?vue&type=template&id=27044f95"
import script from "./TotalTurnoverToPlayTurnTable.vue?vue&type=script&lang=js"
export * from "./TotalTurnoverToPlayTurnTable.vue?vue&type=script&lang=js"
import style0 from "./TotalTurnoverToPlayTurnTable.vue?vue&type=style&index=0&id=27044f95&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports